
















































































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class HikariDifferenceBetween1GAnd10GModal extends Vue {
  @Prop() name!: string;

  hide(deviceType: string) {
    this.$modal.hide(`${this.name}_${deviceType}`);
  }
}
